// tslint:disable:max-line-length
export const HOME_DESCRIPTION_TITLE = `Find Flexible Food Delivery Opportunities`
export const HOME_DESCRIPTION_CONTENT = `Are you looking for a full-time or part-time job? Deliver with DoorDash instead and be your own boss. Work when you want, wherever you want. Here you'll find all open opportunities to deliver using DoorDash across the US and Canada.`

export enum PageTypes {
  LandingPage = 'landing_page',
  CityPage = 'city_page',
  JobPage = 'job_page',
}
